import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";

import { env } from "../../config/env";

export interface CoreUpdateInput {
	name: string;
	pulled_lat: number;
	pulled_lon: number;
	core_length_cm: number;
}

export class MissionsAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/mission`;
	}

	/** Apply manual per-core edits (pulled lat/lon + core length). The backend sets the
	 * supplied values verbatim. */
	public async updateCores(jobId: string, cores: CoreUpdateInput[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/update`;
		await apiClient.post(url, cores, {
			...StandardAxiosConfig(),
		});
	}

	/** Delete the specified core from the mission */
	public async deleteCore(jobId: string, coreId: string): Promise<void> {
		await this.deleteCores(jobId, [coreId]);
	}

	/** Delete the specified cores from the mission */
	public async deleteCores(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/delete`;
		await apiClient.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}
}
